module.exports = __webpack_public_path__ + "img/default-avatar_bg.8bc987a2.png";